import React, { useState } from 'react';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import Color from './Color';
import Ranking from './Ranking';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
}

export default function ShopPage() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth={false}>
      <PageHeader title="Shop" />

      <Box mt={2}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="shop tabs">
          <Tab label="Colors" />
          <Tab label="Ranking" />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <Color />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <Ranking />
        </TabPanel>
      </Box>
    </Container>
  );
}
